import React, { useState, useCallback, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { J, labelStyle } from '../FormBuilderFormStyles';

export default function Tooltip({ tip, children }) {
    const [visible, setVisible] = useState(false);
    const [pos, setPos] = useState({ top: 0, left: 0 });
    const btnRef = useRef(null);

    const show = () => {
        if (btnRef.current) {
            const r = btnRef.current.getBoundingClientRect();
            setPos({ top: r.bottom + 4, left: r.left });
        }
        setVisible(true);
    };

    return (
        <span
            ref={btnRef}
            onMouseEnter={show}
            onMouseLeave={() => setVisible(false)}
            style={{ cursor: 'help', display: 'inline-flex', alignItems: 'center' }}
        >
            {children}
            {visible &&
                createPortal(
                    <span
                        style={{
                            position: 'fixed',
                            left: pos.left,
                            top: pos.top,
                            zIndex: 99999,
                            background: J.tooltipBg,
                            border: '1px solid ' + J.tooltipBorder,
                            borderRadius: 4,
                            padding: '6px 10px',
                            fontSize: 11,
                            color: J.muted,
                            whiteSpace: 'pre-wrap',
                            width: 220,
                            lineHeight: 1.5,
                            pointerEvents: 'none',
                            boxShadow: '0 4px 16px rgba(0,0,0,0.5)',
                            fontFamily: "'Plus Jakarta Sans', sans-serif",
                        }}
                    >
                        {tip}
                    </span>,
                    document.body,
                )}
        </span>
    );
}
